'use client';

import { useEffect } from 'react';

export type IFrameBustOutComponentProps = {
  isPunchoutUser: boolean;
};

export function IFrameBustOutComponent({
  isPunchoutUser,
}: IFrameBustOutComponentProps) {
  useEffect(() => {
    if (isPunchoutUser || typeof window === 'undefined') return;

    // Check if we've already attempted bust-out to prevent infinite loops
    const attemptedKey = 'iframe-bustout-attempted';
    if (sessionStorage.getItem(attemptedKey)) return;

    try {
      if (window.self !== window.top) {
        // Mark that we've attempted bust-out
        sessionStorage.setItem(attemptedKey, 'true');
        window.top!.location.href = window.location.href;
      }
    } catch (error) {
      // Cross-origin restriction - try alternative method
      try {
        sessionStorage.setItem(attemptedKey, 'true');
        window.top!.location.replace(window.location.href);
      } catch {
        // If all else fails, just mark as attempted and don't reload
        // The user will remain in the iframe but won't get stuck in a loop
        sessionStorage.setItem(attemptedKey, 'true');
        console.warn(
          'Unable to break out of iframe due to cross-origin restrictions',
        );
      }
    }
  }, [isPunchoutUser]);

  return null;
}
